import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn.js';
const VARIANT = {
    primary: 'bg-forest text-paper hover:bg-forest/90 focus-visible:ring-forest/40 disabled:bg-forest/40',
    secondary: 'bg-paper text-forest border border-forest hover:bg-forest/5 focus-visible:ring-forest/40 disabled:opacity-50',
    ghost: 'bg-transparent text-forest hover:bg-forest/5 focus-visible:ring-forest/40 disabled:opacity-50',
    danger: 'bg-danger text-paper hover:bg-danger/90 focus-visible:ring-danger/40 disabled:bg-danger/40',
};
const SIZE = {
    sm: 'text-sm px-3 py-1.5 rounded-sm',
    md: 'text-base px-4 py-2 rounded-md',
    lg: 'text-lg px-6 py-3 rounded-md',
};
/**
 * Primary button. Variants: primary (forest fill) / secondary (forest
 * outline) / ghost (text-only) / danger (red fill for destructive
 * actions).
 *
 * Loading state shows a spinner and disables interaction; the
 * `disabled` prop has the same effect minus the spinner.
 */
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', loading, disabled, className, children, ...rest }, ref) {
    return (_jsxs("button", { ref: ref, disabled: disabled || loading, className: cn('inline-flex items-center justify-center gap-2 font-body font-medium transition-colors', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream', 'disabled:cursor-not-allowed', VARIANT[variant], SIZE[size], className), "aria-busy": loading || undefined, ...rest, children: [loading && (_jsxs("svg", { className: "h-4 w-4 animate-spin", fill: "none", viewBox: "0 0 24 24", "aria-hidden": "true", children: [_jsx("circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeOpacity: "0.25", strokeWidth: "4" }), _jsx("path", { fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z" })] })), children] }));
});
//# sourceMappingURL=Button.js.map